var _excluded = ["padding", "paddingVertical", "paddingHorizontal", "paddingTop", "paddingBottom", "paddingLeft", "paddingRight", "margin", "marginVertical", "marginHorizontal", "marginTop", "marginBottom", "marginLeft", "marginRight", "display", "width", "minWidth", "maxWidth", "height", "minHeight", "maxHeight", "alignItems", "justifyContent", "flexDirection", "flexWrap", "flexGrow", "flexShrink", "textAlign", "background", "color", "borderRadius", "boxShadow", "gap", "lineHeight", "position", "overflow", "zIndex", "isolate", "borderStyle", "borderColor", "borderWidth", "as"];
var _templateObject, _templateObject2, _templateObject3;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} /* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import styled, { css } from "styled-components";
import { m, p } from "../spacing";
import { isList, spacingPropTypeMap } from "../utils";
import { margins } from "./lib/margin";
import { paddings } from "./lib/padding";
import { display, displayPropTypeMap } from "./lib/display";
import { width, maxWidth, height, maxHeight, dimensionPropTypeMap, minWidth, minHeight } from "./lib/dimensions";
import { alignItems, alignItemsPropTypeMap, justifyContent, justifyContentPropTypeMap, flexDirection, flexDirectionPropTypeMap, flexWrap, flexWrapPropTypeMap, flexGrow, flexGrowPropTypeMap, flexShrink, flexShrinkPropTypeMap } from "./lib/flex";
import { textAlign, textAlignPropTypeMap } from "./lib/textAlign";
import { background, color, colorsPropType, colorsPropTypeMap } from "./lib/colors";
import { borderRadius, borderRadiusPropTypeMap } from "./lib/border-radius";
import { boxShadow, boxShadowPropTypeMap } from "./lib/box-shadow";
import { gap } from "./lib/gap";
import { lineHeight, lineHeightPropTypeMap } from "./lib/line-height";
import { position, positionPropTypeMap, elementPositionPropTypeMap } from "./lib/position";
import { overflow, overflowPropTypeMap } from "./lib/overflow";
import { border, borderStylePropTypeMap } from "./lib/border";
import { zIndex, zIndexPropTypeMap } from "./lib/z-index";
export var Box = styled(function (_ref) {
  var padding = _ref.padding,
    paddingVertical = _ref.paddingVertical,
    paddingHorizontal = _ref.paddingHorizontal,
    paddingTop = _ref.paddingTop,
    paddingBottom = _ref.paddingBottom,
    paddingLeft = _ref.paddingLeft,
    paddingRight = _ref.paddingRight,
    margin = _ref.margin,
    marginVertical = _ref.marginVertical,
    marginHorizontal = _ref.marginHorizontal,
    marginTop = _ref.marginTop,
    marginBottom = _ref.marginBottom,
    marginLeft = _ref.marginLeft,
    marginRight = _ref.marginRight,
    display = _ref.display,
    width = _ref.width,
    minWidth = _ref.minWidth,
    maxWidth = _ref.maxWidth,
    height = _ref.height,
    minHeight = _ref.minHeight,
    maxHeight = _ref.maxHeight,
    alignItems = _ref.alignItems,
    justifyContent = _ref.justifyContent,
    flexDirection = _ref.flexDirection,
    flexWrap = _ref.flexWrap,
    flexGrow = _ref.flexGrow,
    flexShrink = _ref.flexShrink,
    textAlign = _ref.textAlign,
    background = _ref.background,
    color = _ref.color,
    borderRadius = _ref.borderRadius,
    boxShadow = _ref.boxShadow,
    gap = _ref.gap,
    lineHeight = _ref.lineHeight,
    position = _ref.position,
    overflow = _ref.overflow,
    zIndex = _ref.zIndex,
    isolate = _ref.isolate,
    borderStyle = _ref.borderStyle,
    borderColor = _ref.borderColor,
    borderWidth = _ref.borderWidth,
    as = _ref.as,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    "data-mesh-component": "BOX"
  }, rest));
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n\n  // If box is set to be a ul or ol we need to reset the default styling\n  ", "\n\n  ", "\n\n  ", ";\n  ", ";\n\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), function (_ref2) {
  var as = _ref2.as;
  return as && isList(as) && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      ", ";\n      ", ";\n      list-style-type: none;\n    "])), m(0), p(0));
}, function (_ref3) {
  var isolate = _ref3.isolate;
  return isolate && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      isolation: isolate;\n    "])));
}, function (props) {
  return margins(props);
}, function (props) {
  return paddings(props);
}, function (props) {
  return display(props);
}, function (props) {
  return width(props);
}, function (props) {
  return minWidth(props);
}, function (props) {
  return maxWidth(props);
}, function (props) {
  return height(props);
}, function (props) {
  return minHeight(props);
}, function (props) {
  return maxHeight(props);
}, function (props) {
  return alignItems(props);
}, function (props) {
  return justifyContent(props);
}, function (props) {
  return flexDirection(props);
}, function (props) {
  return flexWrap(props);
}, function (props) {
  return flexGrow(props);
}, function (props) {
  return flexShrink(props);
}, function (props) {
  return textAlign(props);
}, function (props) {
  return background(props);
}, function (props) {
  return color(props);
}, function (props) {
  return borderRadius(props);
}, function (props) {
  return boxShadow(props);
}, function (props) {
  return gap(props);
}, function (props) {
  return lineHeight(props);
}, function (props) {
  return position(props);
}, function (props) {
  return overflow(props);
}, function (props) {
  return border(props);
}, function (props) {
  return zIndex(props);
});
Box.displayName = "Box";